import { List, SearchInput, useGetRecordId } from "react-admin";
import { DateTime } from "luxon";
import { QuickFilter } from "../../misc/QuickFilter";
import { dateBefore, dateBetween, isNonEmptyString } from "../../utils/filters";
import { EmptyState } from "../../misc/EmptyState";
import { PageTitle } from "../../misc/PageTitle";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { ExaminationAssignmentsDataGrid } from "./ExaminationAssignmentsDataGrid";

const filters = [
  <SearchInput source="q" alwaysOn />,
  <QuickFilter label="gültige Prüfaufträge" source="__valid_examination_assignments__" defaultValue={true} />,
  <QuickFilter label="abgelaufene Prüfaufträge" source="__expired_examination_assignments__" defaultValue={true} />,
];

export function DrivingSchoolExaminationAssignments({
  title,
  expirationState,
}: {
  title: string;
  expirationState?: "expiringSoon" | "expired";
}) {
  const drivingSchoolId = useGetRecordId();

  let expirationFilter = isNonEmptyString;
  if (expirationState === "expiringSoon") {
    expirationFilter = dateBetween(DateTime.now(), DateTime.now().plus({ months: 3 }));
  } else if (expirationState === "expired") {
    expirationFilter = dateBefore(DateTime.now());
  }

  const empty = (
    <EmptyState
      noEntriesText="Noch kein Prüfauftrag hinterlegt."
      noMatchingEntriesText="Keine passenden Prüfaufträge gefunden."
    />
  );
  const listKey = `${expirationState ? `${expirationState}-` : ""}examinationAssignments`;

  return (
    <div style={{ position: "relative" }}>
      <PageTitle>{title}</PageTitle>
      <ResponsiveListSurface
        variant="compactStandalone"
        data-testid="DrivingSchoolExaminationAssignments"
        sx={{ pt: { sm: "20px" } }}
      >
        <List
          resource="examinationAssignments"
          key={listKey}
          title=" "
          filter={{
            drivingSchoolId,
            examinationAssignmentExpiresAt: expirationFilter,
            status: ["active"],
          }}
          filters={expirationState ? [<SearchInput source="q" alwaysOn />] : filters}
          storeKey={`DrivingSchoolExaminationAssignments@${drivingSchoolId}@${expirationState ?? "all"}`}
          sort={/* initial sort order: */ { field: "examinationAssignmentExpiresAt", order: "ASC" }}
          exporter={false}
          empty={empty}
        >
          <ExaminationAssignmentsDataGrid empty={empty} />
        </List>
      </ResponsiveListSurface>
    </div>
  );
}
